import React, {useContext} from 'react'
import {
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    Flex,
    useMultiStyleConfig,
    Button,
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {ActionsContext} from '../order-context'

const ReturnOrderConfirmationModal = ({isOpen, onClose, refetchOrder}) => {
    const styles = useMultiStyleConfig('Orders')
    const dispatch = useContext(ActionsContext)
    const handleGoBackToDetailClick = () => {
        refetchOrder()
        dispatch({type: 'SET_ACTIVE_SHIPMENT', payload: ''})
        onClose()
    }
    return (
        <Modal isOpen={isOpen} onClose={handleGoBackToDetailClick} isCentered>
            <ModalOverlay />
            <ModalContent {...styles.returnModalContainer}>
                <ModalHeader width={'100%'} padding={0}>
                    <Flex {...styles.returnModalHeader}>
                        <Flex>
                            <Text {...styles.returnModalTitle}>
                                <FormattedMessage
                                    id="return_order_confirmation_modal.title"
                                    defaultMessage="Done!"
                                />
                            </Text>
                        </Flex>
                    </Flex>
                </ModalHeader>
                <ModalBody data-testid="modal-body" padding={0} width={'100%'}>
                    <Flex alignItems="flex-start" flexDirection="column" width={'100%'}>
                        <Text {...styles.returnConfirmationModalDescription}>
                            <FormattedMessage
                                id={`return_order_confirmation_modal.email`}
                                defaultMessage="You will soon receive an email with further instructions"
                            />
                        </Text>
                        <Button
                            variant={'primary'}
                            {...styles.returnModalConfirmationButton}
                            onClick={handleGoBackToDetailClick}
                        >
                            <FormattedMessage
                                id="return_order_confirmation_modal.button"
                                defaultMessage="Back to order details"
                            />
                        </Button>
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

ReturnOrderConfirmationModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    refetchOrder: PropTypes.func,
}

export default ReturnOrderConfirmationModal
